import React from "react";
import PropTypes from "prop-types";
import {
    Form,
    FormGroup,
    Label,
    Input,
    Col,
    Button,
} from "reactstrap";
import JsonEditor from "./JsonEditor";

/**
 * Placement Edit Form Component
 */
const PlacementEditForm = ({
    shop,
    value,
    field,
    jsonError,
    onInputChange,
    onJsonChange,
    onSubmit,
}) => {
    const getFieldLabel = () => {
        switch (field) {
            case "total_fees":
                return "Total Fees";
            case "placement":
                return "Placement";
            case "public_access_token":
                return "Access Token";
            case "cart_location":
                return "Cart Location";
            default:
                return field;
        }
    };

    return (
        <Form onSubmit={onSubmit}>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-shop-Input"
                    className="col-sm-1 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    Store Domain
                </Label>
                <Col sm={4}>
                    <Input
                        value={shop}
                        type="text"
                        name="shop"
                        className="form-control"
                        id="horizontal-shop-Input"
                        onChange={onInputChange}
                        readOnly
                    />
                </Col>
            </FormGroup>
            <FormGroup className="row mb-4">
                <Label
                    htmlFor="horizontal-placement-Input"
                    className="col-sm-1 col-form-label text-md-right"
                    style={{ textAlign: "center" }}
                >
                    {getFieldLabel()}
                </Label>
                {field !== "cart_location" && (
                    <Col sm={4}>
                        <Input
                            value={value}
                            type="string"
                            name="value"
                            className="form-control"
                            id="horizontal-placement-Input"
                            onChange={onInputChange}
                            required
                        />
                    </Col>
                )}
                {field === "cart_location" && (
                    <Col sm={4}>
                        <JsonEditor initialValue={value} onChange={onJsonChange} />
                        <p style={{ color: 'red' }}>{jsonError || ""}</p>
                    </Col>
                )}
            </FormGroup>
            <FormGroup className="row justify-content-end">
                <Col sm={11}>
                    <div>
                        <Button
                            type="submit"
                            color="primary"
                            className="w-md"
                        >
                            Update
                        </Button>
                    </div>
                </Col>
            </FormGroup>
        </Form>
    );
};

PlacementEditForm.propTypes = {
    shop: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]).isRequired,
    field: PropTypes.string.isRequired,
    jsonError: PropTypes.string,
    onInputChange: PropTypes.func.isRequired,
    onJsonChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

export default PlacementEditForm;

